import { depositFormService } from '../api/services';
import { prepareIdentityImage } from './identityImage';

// This cache lives only inside the mounted form; no identity data goes to localStorage.
export const createIdentityReader = () => {
  let cache = new WeakMap();
  const controllers = new Set();
  return {
    read(file, side, force = false) {
      let sides = cache.get(file);
      if (!sides) { sides = new Map(); cache.set(file, sides); }
      const current = sides.get(side);
      if (current && (!force || !current.settled)) return current.promise;
      const controller = new AbortController();
      controllers.add(controller);
      const entry = { settled: false, promise: null };
      entry.promise = (async () => {
        try {
          const copy = await prepareIdentityImage(file);
          if (controller.signal.aborted) throw new Error('Reading cancelled');
          const data = new FormData();
          data.append(side === 'front' ? 'id_front' : 'id_back', copy);
          const result = await depositFormService.extractIdentity(data, controller.signal);
          if (!Object.keys(result || {}).length && sides.get(side) === entry) sides.delete(side);
          return result || {};
        } catch (error) {
          if (sides.get(side) === entry) sides.delete(side);
          throw error;
        } finally {
          entry.settled = true;
          controllers.delete(controller);
        }
      })();
      sides.set(side, entry);
      return entry.promise;
    },
    cancel() {
      controllers.forEach((controller) => controller.abort());
      controllers.clear();
      cache = new WeakMap();
    },
  };
};
